import React from "react";
import { Route } from "react-router-dom";
import MainLayout from "../../components/MainLayout/MainLayout";
import { AuthenticationGuard } from "../../components/AuthenticationGuard/AuthenticationGuard";
import PermissionGuard from "@/components/PermissionGuard/PermissionGuard";

// Lazy load route components
const CapExReport = React.lazy(() =>
  import("@/modules/capex/features/CapExReport/components").then((m) => ({
    default: m.CapExReport,
  })),
);
const MonthlySummary = React.lazy(() =>
  import("@/modules/capex/features/MonthlySummary/components").then((m) => ({
    default: m.MonthlySummary,
  })),
);
const BulkHours = React.lazy(() =>
  import("@/modules/capex/features/BulkHours/components").then((m) => ({
    default: m.BulkHours,
  })),
);
const CapExLayout = React.lazy(() =>
  import("@/modules/capex/features/shared/CapExLayout").then((m) => ({
    default: m.CapExLayout,
  })),
);

// Create stable component reference
const CapExMainLayout = () => <MainLayout section="admin" />;

const CapExRoutes = (
  <Route
    element={<AuthenticationGuard component={CapExMainLayout} />}
    path="/capex"
  >
    {/* Shared token gate / Update Token experience for all CapEx pages */}
    <Route element={<CapExLayout />}>
      <Route
        element={
          <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN", "ROLE_USER"]}>
            <CapExReport />
          </PermissionGuard>
        }
        index
      />
      <Route
        element={
          <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN", "ROLE_USER"]}>
            <MonthlySummary />
          </PermissionGuard>
        }
        path="summary"
      />
      <Route
        element={
          <PermissionGuard requiredRoles={["ROLE_SUPER_ADMIN", "ROLE_USER"]}>
            <BulkHours />
          </PermissionGuard>
        }
        path="bulk-hours"
      />
    </Route>
  </Route>
);

export default CapExRoutes;
